export default __webpack_public_path__ + "static/media/healthcare-icon.cded1aeb.svg";